import { PageContentWrapper } from '@lmc/ui-kit'
import useHomeType from 'hooks/useHomeType'
import { RotaPatternEditForm } from '../RotaPattern'

export const RotaEditShiftsScreen = () => {
  const { hasRota } = useHomeType()

  if (!hasRota) {
    return null
  }

  return (
    <PageContentWrapper $paddingTop={24} $paddingX={48} $paddingBottom={24}>
      <RotaPatternEditForm type="shift" />
    </PageContentWrapper>
  )
}
